import { render, staticRenderFns } from "./capitalFlow.vue?vue&type=template&id=fed04400"
import script from "./capitalFlow.vue?vue&type=script&lang=js"
export * from "./capitalFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports